<template lang="pug">
div.animated.fadeIn
  b-card
    div.row
      div.col-sm-5
        h4.card-title.mb-0
          | Interactions (Live)
        div.small.text-muted
          | Displaying Live Interactions
      div.col-sm-7.hidden-sm-down
        div(v-if='userAccessLevel != "agent"')
          b-btn.pull-right.ml-1(type='button', variant='danger', v-if='!paused', @click='bossPause', :disabled='loadingPause')
            i.fa.fa-pause
            | &nbsp;&nbsp;Pause Autoreply
          b-btn.pull-right.ml-1(type='button', variant='success', v-if='paused', @click='bossPause', :disabled='loadingPause')
            i.fa.fa-play
            | &nbsp;&nbsp;Resume Autoreply
        //- b-btn.pull-right(type='button', variant='primary')
          i.icon-cloud-download
          |   Export
    br
    div(v-if='loading')
      | {{loadingText}}
    div(v-else)
      div(v-if='tableItemsFlag.length > 0')
        app-interactionsTable(:data='tableItemsFlag', :label='tableFieldsFlag', rowClick)
        <br>
      app-interactionsTable(:data='tableItems', :label='tableFields', v-if='!boss', rowClick)
</template>

<script>
import { db } from '@/firebase'
import { parseMessage } from '../filter'
import { pauseAll, resumeAll } from '@/api'

const msgsRef = db.ref('newestChats')
const usersRef = db.ref('users')
const flagRef = db.ref('flags')
const dRef = db.ref('dashboard')

function fullNameElseID(key, val) {
  if (val.firstName && val.lastName) {
    return val.firstName + ' ' + val.lastName
  } else if (val.name) {
    return val.name
  } else if (val.shortID) {
    return 'Guest'
    // this is short key
    // return val.shortID
  } else {
    return 'Guest'
    // this is long key
    // return key
  }
}

export default {
  name: 'dashboard',
  props: ['boss'],
  data() {
    return {
      firstSendObj: {},
      timeout: [],
      refreshPage: false,
      finishedRefresh: true,
      userAccessLevel: this.$store.state.profile.accessLevel,
      loading: true,
      paused: null,
      interval: null,
      loadingPause: null,
      actions1: [{ name: 'View More' }],
      loadingText: 'Loading...',
      tableItems: [],
      tableFields: {
        avatar: {
          label: 'Status',
        },
        messageId: {
          label: 'Customer Name / ID',
        },
        userMessage: {
          label: 'User Message',
        },
        message: {
          label: 'Bot Message',
        },
        flagHandleBy: {
          label: 'Resolved By',
        },
        firstInteraction: {
          label: 'First Interaction',
        },
        numTimestamp: {
          label: 'Last Interaction',
        },
        sentiment: {
          label: 'Sentiment',
        },
      },
      tableItemsFlag: [],
      tableFieldsFlag: {
        avatar: {
          label: 'Status',
        },
        messageId: {
          label: 'Customer Name / ID',
        },
        userMessage: {
          label: 'User Message',
        },
        message: {
          label: 'Bot Message',
        },
        flagHandleBy: {
          label: 'Resolved By',
        },
        firstInteraction: {
          label: 'First Interaction',
        },
        numTimestamp: {
          label: 'Last Interaction',
        },
        quicksend: {
          label: '<i></i>',
          class: 'text-right',
          thStyle: {
            minWidth: '14em',
          },
        },
        agent: {
          label: 'Agent',
          class: 'text-center',
        },
      },
    }
  },
  methods: {
    paginate(p) {
      const self = this
      return new Promise(async (resolve) => {
        var msgs
        var msgsFlag
        var users
        var flags
        var messageKey
        msgsRef.limitToLast(p * 15).once('value', async (snapshot) => {
          msgs = []
          msgsFlag = []
          users = {}
          var keys = []
          var numOfFlag = 0
          var currentNumFlag = 0
          var iterator = 0
          var promiseArray = []
          promiseArray.push(flagRef.once('value').then((snapshot) => {
            numOfFlag = snapshot.numChildren()
            flags = {}
            messageKey = {}
            var senderID
            if (window.localStorage.getItem('firstSendObj') !== null) {
              self.firstSendObj = JSON.parse(window.localStorage.getItem('firstSendObj'))
            }
            snapshot.val() && Object.entries(snapshot.val()).forEach(
              function([key, val]) {
                try {
                  senderID = val.senderID || val.userID
                  flags[senderID] = val.agent || ' '
                  messageKey[senderID] = key
                } catch (error) {
                  console.log('no uid: ' + error)
                }
              })
            Object.entries(self.firstSendObj).forEach(
              function([key, val]) {
                if (messageKey.hasOwnProperty(key) === false) {
                  delete self.firstSendObj[key]
                  window.localStorage.setItem('firstSendObj', JSON.stringify(self.firstSendObj))
                }
              })
          }))
          // var prev = [] // check if previous record exist
          snapshot.forEach((child) => {
            keys.unshift(child.key)
            try {
              promiseArray.push(usersRef.child(child.val().userID).once('value').then((ss) => {
                users[child.val().userID] = ss.val()
              }))
            } catch (error) {}
          })
          await Promise.all(promiseArray)
          for (var k of keys) {
            if (numOfFlag <= currentNumFlag && iterator >= (p * 10)) {
              break
            }
            try {
              var icPattern = /\d{2}[0-1]\d{1}[0-3]\d{1}-?\d{2}-?\d{4}/
              var cdsPattern = /\d{10}/
              if (iterator >= (p * 10)) {
                if (!snapshot.val()[k].flagged) {
                  continue
                }
              }
              var val = snapshot.val()[k]
              var senderID = val.senderID || val.userID
              if (users[senderID]) {
                val.username = fullNameElseID(senderID, users[senderID])
                val.url = users[senderID].profilePic || 'static/img/avatars/0.png'
                val.status = users[senderID].status || 'danger'
                val.takeover = users[senderID].takeover || false
                val.firstInteraction = users[senderID].firstInteraction || '-'
                val.flagHandleBy = users[senderID].flagHandleBy || ['Not Applicable']
              } else {
                val.username = senderID
                val.url = 'static/img/avatars/0.png'
                val.status = 'danger'
                val.takeover = false
                val.firstInteraction = '-'
                val.flagHandleBy = ['Not Applicable']
              }
              var d = new Date()
              // Massage msg
              var cutOff = 50
              var message = parseMessage(val.message, cutOff)
              var flagHandleByString
              if (val.flagHandleBy != ['Not Applicable']) {
                flagHandleByString = val.flagHandleBy.join(', ')
              } else {
                flagHandleByString = 'Not Applicable'
              }
              var platform = val.platform ? val.platform.source : ''
              var msg = {
                avatar: { url: val.url, status: val.status, platform, tooltip: k },
                userId: senderID,
                userMessage: val.userMessage ? val.userMessage.split(icPattern).join('••••IC NO••••').split(cdsPattern).join('•••CDS••••') : '',
                rawMsg: val.message,
                sentiment: {
                  score: `${Math.round(val.sentiment * 100)}%`,
                  number: val.sentiment,
                },
                agent: { url: flags[senderID] && flags[senderID] !== ' ' && 'static/img/avatars/0.png', status: 'success', tooltip: flags[senderID] },
                messageId: val.username,
                flagHandleBy: { id: senderID, flagHandleBy: val.flagHandleBy, flagHandleByString },
                numTimestamp: val.timestamp,
                firstInteraction: val.firstInteraction,
                message: message.split(icPattern).join('••••IC NO••••').split(cdsPattern).join('•••CDS••••'),
                _rowVariant: ((d - val.timestamp) < 300000) && 'success',
              }
              if (msg.userId && val.flagged == true) {
                msg._rowVariant = 'danger'
                for (var j = 0; j < msgsFlag.length; j++) {
                  if (msgsFlag[j].userId == msg.userId) {
                    msgsFlag.splice(j, 1)
                  }
                }
                msgsFlag.unshift(msg)
                currentNumFlag += 1
              } else {
                senderID && msgs.push(msg)
                iterator += 1
              }
            } catch (error) {
              console.log(error)
            }
          }
          self.tableItemsFlag = msgsFlag
          self.tableItems = msgs
          resolve('completed')
          msgs = []
          msgsFlag = []
          users = {}
          flags = {}
          messageKey = {}
        })
      })
    },
    bossPause() {
      // if false, (i.e. NOT paused) our action
      // should be pauseAll

      // so if true, our action is resumeAll
      const p = this.paused
      this.paused = !this.paused
      this.loadingPause = true
      const self = this
      setTimeout(function() {
        self.loadingPause = false
      }, 5000)
      dRef.update({
        pauseToggle: this.paused,
      })
      if (!p) {
        pauseAll()
      } else {
        resumeAll()
      }
    },
  },
  watch: {
    refreshPage() {
      var p = 1
      var that = this
      if (this.finishedRefresh == true && this.refreshPage == true) {
        const self = this
        var int = setInterval(async () => {
          for (var i = 0; i < that.timeout.length; i++) {
            clearTimeout(that.timeout[i])
          }
          that.timeout = []
          that.refreshPage = false
          that.finishedRefresh = false
          self.paginate(p).then((res) => {
            for (var ite = 0; ite < 28; ite++) {
              if (self.tableItems[ite] && self.tableItems[ite]._rowVariant == 'success') {
                var i = ite
                that.timeout.push(setTimeout(() => {
                  self.tableItems[i]._rowVariant = ''
                }, 300000 - (new Date() - self.tableItems[i].numTimestamp)))
              }
            }
            if (that.refreshPage == false) {
              clearInterval(int)
              that.finishedRefresh = true
              self.loading = false
            }
          })
        }, 1000)
      }
      that.timeout = []
      self.tableitems = []
    },
  },
  mounted: async function() {
    dRef.on('value', (snapshot) => {
      this.paused = snapshot.child('pauseToggle').val()
    })
    const self = this
    msgsRef.limitToLast(2).on('value', (snapshot) => {
      self.refreshPage = true
    })
  },
  beforeDestroy: function() {
    clearInterval(this.interval)
    msgsRef.off('value')
  },
}
</script>



// WEBPACK FOOTER //
// src/views/InteractionsRT.vue?750edbed